export enum SubscriptionProductType {
  PlatformResearch = "PlatformResearch"
}

export enum SubscriptionProductPriceType {
  Full = "Full"
}